import { render, staticRenderFns } from "./SphereDetail.vue?vue&type=template&id=591d8a06&scoped=true&"
import script from "./SphereDetail.vue?vue&type=script&lang=js&"
export * from "./SphereDetail.vue?vue&type=script&lang=js&"
import style0 from "./SphereDetail.vue?vue&type=style&index=0&id=591d8a06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d8a06",
  null
  
)

export default component.exports